import { Image2dGrayComponent } from './image2d-gray/image2d-gray.component';
import { NgThreeModule } from './../ng3/ng3.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WindowComponent } from './window/window.component';
import { DirectionComponent } from './direction/direction.component';
import { ColormapComponent } from './colormap/colormap.component';
import { Image2dComponent } from './image2d/image2d.component';
import { Image3dComponent } from './image3d/image3d.component';
import {ImagecrosslineComponent} from './imagecrossline/imagecrossline.component';

@NgModule({
  declarations: [
    ColormapComponent,
    DirectionComponent,
    WindowComponent,
    Image3dComponent,
    Image2dComponent,
    ImagecrosslineComponent,
    Image2dGrayComponent
  ],
  imports: [CommonModule, NgThreeModule],
  exports: [
    ColormapComponent,
    DirectionComponent,
    WindowComponent,
    Image3dComponent,
    Image2dComponent,
    NgThreeModule,
    ImagecrosslineComponent,
    Image2dGrayComponent
  ],
})
export class ImageSliceShowModule {}
